import ApiHttpHandler from "./apiHttpHandler";
const handler = new ApiHttpHandler();
const canControlDrone = (droneId) => {
    return handler.get(`control/can-control/${droneId}`);
};
const getControlToken = (password) => {
    return handler.post(`control/token`, { password });
};
export default {
    canControlDrone,
    getControlToken,
};
